import React from 'react';
import SolutionInstallmentExaminationConfirmWrapper from 'components/SolutionInstallmentExaminationConfirmWrapper/SolutionInstallmentExaminationConfirmWrapper';

export default function SolutionInstallmentExaminationConfirmContainer() {
    return (
        <SolutionInstallmentExaminationConfirmWrapper />
    )
}
